import { render } from "./3.ResourcesStep.vue?vue&type=template&id=5d569a4a"
import script from "./3.ResourcesStep.vue?vue&type=script&lang=js"
export * from "./3.ResourcesStep.vue?vue&type=script&lang=js"

import "./3.ResourcesStep.vue?vue&type=style&index=0&id=5d569a4a&lang=scss"

import exportComponent from "/Volumes/Samsung_T5/Work/Projects/my_projects/profiguide/profiguide/src/profiguide/static/web_plugin/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__